import { render, staticRenderFns } from "./GeneralInformationView.vue?vue&type=template&id=732a080c&scoped=true"
import script from "./GeneralInformationView.vue?vue&type=script&lang=js"
export * from "./GeneralInformationView.vue?vue&type=script&lang=js"
import style0 from "./GeneralInformationView.vue?vue&type=style&index=0&id=732a080c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732a080c",
  null
  
)

export default component.exports